import React from 'react';

export default function Thumbnail(props) {
    const {
        image_source,
        name,
        job_title,
    } = props;

    return (
        <div className="h-100 thumbnail align-items-center card">
            <img
                alt={`Image of ${name}`}
                className="img card-img"
                src={image_source}/>
            <div className="card-body px-1 py-2">
                <div className="card-title">
                    <strong>{name}</strong>
                </div>
                <div className="card-text" dangerouslySetInnerHTML={{ __html: job_title }}>
                </div>
            </div>
        </div>
    );
}
    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.undefined = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<undefined {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())